import './VideoPlayer.less';
import React, {useState, useEffect} from 'react';
import AspectContainer from "../../../bootstrap/components/aspect-container/AspectContainer";
import VideoHelper from "../../helpers/VideoHelper";


export default function VideoPlayer({video, autoPlay}) {

    return <div className="video-player">
        <AspectContainer ratio={video.width / video.height}>
            <video src={VideoHelper.getUrl(video)} controls={true} controlsList="nodownload" autoPlay={autoPlay}/>
        </AspectContainer>
    </div>;
}
